import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function stripHtmlTags(input: string): string {
  if (!input) return '';
  return input.replace(/<\/?[^>]+(>|$)/g, '').trim();
}

export function strippedLengthValidator(min: number, max?: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const plainText = stripHtmlTags(control.value);
    if (plainText.length && plainText.length < min) {
      return { minlength: { requiredLength: min, actualLength: plainText.length } };
    }
    if (plainText.length && max && plainText.length > max) {
      return { maxlength: { requiredLength: max, actualLength: plainText.length } };
    }
    return null;
  };
}